export enum TwoFactorMethod {
  EMAIL = "EMAIL",
  TOTP = "TOTP",
}
